import React from 'react';
import {Alert, Button, Form, Input, Popconfirm, Select, TimePicker} from "antd";
import {DeleteOutlined, QuestionCircleOutlined, SaveOutlined} from "@ant-design/icons";
import './EditTask.less';
import TextArea from "antd/es/input/TextArea";
import NewTask from "./NewTask";
import moment from 'moment';
import Server from "../../helpers/Server";
import SData from "../../helpers/SData";
import SystemFunctions from "../../helpers/SystemFunctions";

export default class EditTask extends React.PureComponent {

    form = React.createRef();
    lastPropsTaskId = null;

    constructor(props, context) {
        super(props, context);

        this.state = {
            editTaskName: '',
            editTaskNameError: '',
            editTaskDescription: '',
            editTaskTime: '',
            editTaskTags: [],
            loadingEdit: false,
            loadingDelete: false,
            errorText: '',
        };
    }

    checkNewTask = () => {
        if (this.lastPropsTaskId !== this.props.taskData.id) {
            this.lastPropsTaskId = this.props.taskData.id;
            let time = this.props.taskData.time;
            let h = Math.floor(time / 60);
            let m = time - h * 60;
            this.setState({
                editTaskName: this.props.taskData.name,
                editTaskNameError: '',
                editTaskDescription: this.props.taskData.data.description == null ? '' : this.props.taskData.data.description,
                editTaskTime: moment(`${h}:${m}`, 'HH:mm'),
                editTaskTags: this.props.taskData.tags,
            });
            if (this.form != null && this.form.current != null) {
                this.form.current.setFieldsValue({
                    name: this.props.taskData.name,
                });
            }
        }
    }

    render() {
        this.checkNewTask();
        return (<div className='EditTask'>
            <Form name="editTask"
                  ref={this.form}
                  className="taskEditPanelForm"
                  initialValues={{remember: true}}
                  onFinish={this.onClickEdit}>
                <Form.Item name="name"
                           className='taskName'
                           validateStatus={this.state.editTaskNameError === '' ? null : 'error'}
                           onChange={(v) => {
                               let value = v.target.value;
                               if (this.state.editTaskNameError != '') {
                                   this.setState({
                                       editTaskNameError: ''
                                   });
                               }
                               this.setState({editTaskName: value, errorText: ''})
                           }}
                           initialValue={this.props.taskData?.name}
                           help={this.state.editTaskNameError === '' ? null : this.state.editTaskNameError}>
                    <Input placeholder="Название задачи" autoComplete="off"/>
                </Form.Item>
                <TextArea
                    name='description'
                    className='taskDescription'
                    placeholder="Описание задачи"
                    autoSize={{minRows: 3, maxRows: 8}}
                    value={this.state.editTaskDescription}
                    onChange={(v) => this.setState({editTaskDescription: v.target.value, errorText: ''})}
                />
                <div className='tagsAndTime'>
                    <TimePicker placeholder='Время'
                                className='timePicker'
                                allowClear={false}
                                popupClassName='taskTimePickerPopup'
                                disabledHours={() => [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]}
                                minuteStep={10}
                                format='H:mm'
                                showNow={false}
                                hideDisabledOptions={true}
                                value={this.state.editTaskTime}
                                onSelect={(time) => {
                                    this.setState({editTaskTime: time, errorText: ''});
                                }}
                                onChange={(time, timeString) => this.setState({editTaskTime: time, errorText: ''})}/>
                    <Select
                        className='tagsSelect'
                        mode="multiple"
                        tagRender={NewTask.tagRender(this.props.options)}
                        optionFilterProp="label"
                        options={NewTask.tagsToOptions(this.props.options)}
                        value={this.state.editTaskTags}
                        placeholder='Выберите теги'
                        onChange={(value) => this.setState({editTaskTags: value, errorText: ''})}
                        showArrow
                    />
                </div>
                {this.state.errorText == '' ? null : <Alert
                    message={this.state.errorText}
                    className='errorText'
                    type='error'
                    banner
                />}
                <Form.Item style={{marginBottom: 0}}>
                    <Button icon={<SaveOutlined/>} type="default" htmlType="submit" className="saveButton"
                            loading={this.state.loadingEdit}>
                        Принять изменения
                    </Button>
                    <Popconfirm okText='Да' cancelText='Отмена' okType='error'
                                okButtonProps={{className: 'btn-object'}}
                                cancelButtonProps={{className: 'btn-object'}}
                                disabled={this.state.loadingDelete} onConfirm={this.onClickDelete}
                                title="Вы действительно хотите удалить задачу?"
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}>
                        <Button icon={<DeleteOutlined/>} type="error" className="deleteButton"
                                loading={this.state.loadingDelete}>
                            Удалить задачу
                        </Button>
                    </Popconfirm>
                </Form.Item>
            </Form>
        </div>);
    }

    onClickEdit = (formData) => {
        if (this.state.loadingEdit || this.state.loadingDelete) {
            return;
        }
        let name = this.state.editTaskName;
        let desc = this.state.editTaskDescription;
        let timeObj = this.state.editTaskTime;
        let tags = this.state.editTaskTags;
        let time = timeObj.hours() * 60 + timeObj.minutes();
        if (time == null || time < 1) {
            this.setState({errorText: "Вы не указали время выполнения задачи!"});
            return;
        }
        if (this.props.taskData.name === name && this.props.taskData.time === time && SystemFunctions.compareObjects(this.props.taskData.tags, tags) && this.props.taskData?.data?.description === desc) {
            this.props.close();
            return;
        }
        let id = this.props.taskData.id;
        this.setState({loadingEdit: true});
        Server.query(Server.QUERY_TASKS, {a: 'edit', id, name, time, tags, desc}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerTasks(r.tasks);
                this.props.close();
                this.setState({loadingEdit: false, errorText: ''});
            } else {
                this.setState({loadingEdit: false, errorText: r.error});
            }
        }, () => {
            this.setState({loadingEdit: false, errorText: Server.ERROR_TEXT_CONNECTION});
        });
    }

    onClickDelete = () => {
        if (this.state.loadingEdit || this.state.loadingDelete) {
            return;
        }
        let id = this.props.taskData.id;
        this.setState({loadingDelete: true});
        Server.query(Server.QUERY_TASKS, {a: 'delete', id}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerTasks(r.tasks);
                this.props.close();
                this.setState({loadingDelete: false, errorText: ''});
            } else {
                this.setState({loadingDelete: false, errorText: r.error});
            }
        }, () => {
            this.setState({loadingDelete: false, errorText: Server.ERROR_TEXT_CONNECTION});
        });
    }
}